import { Button } from "@/components/ui/button";
import { HomeIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="text-center p-10 flex flex-col justify-center items-center gap-4 ">
      <HomeIcon className="w-16 h-16 mx-auto" />
      <p className="text-4xl leading-tight border rounded-full px-6 py-2">
        Ops... página não encontrada
      </p>
      <Link to="/">
        <Button>Voltar para a home</Button>
      </Link>
    </div>
  );
}
